export default __webpack_public_path__ + "c262c6b8e43d0e6ead314946f7ae45a8.png";